import { useState } from "react";
import { useNavigate } from "react-router-dom";
import PageLayout from "examples/LayoutContainers/PageLayout";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import Footer from "layouts/authentication/components/Footer";
import SkipToContent from "components/SkipToContent";
import usePageTitle from "utils/usePageTitle";
import pageRoutes from "page.routes";

// MUI Components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Divider from "@mui/material/Divider";

// Components
import Sidebar from "./components/Sidebar";
import ContentDisplay from "./components/ContentDisplay";
import { menuStructure, contentData } from "./data/contentData";

function CeTrebuieSaStii() {
  usePageTitle("Bibliotecă de informații");
  const [activeSection, setActiveSection] = useState("ce-si-cum-raportezi");
  const [activeSubsection, setActiveSubsection] = useState(null);
  const [activeSubSubsection, setActiveSubSubsection] = useState(null);
  const navigate = useNavigate();

  const handleNavigateToForm = () => {
    navigate("/formular-sesizare");
  };

  return (
    <PageLayout>
      <SkipToContent />
      <DefaultNavbar
        routes={pageRoutes}
        transparent
        action={{
          type: "external",
          route: "/formular-sesizare",
          label: "Trimite Sesizare",
          color: "info",
        }}
      />
      
      <SoftBox component="main" id="main-content" tabIndex={-1} sx={{ outline: "none" }} mt={19} mb={5}>
        <Grid container justifyContent="center">
          <Grid item xs={12} lg={11}>
            <SoftBox textAlign="center" mb={4} px={{ xs: 2, sm: 3, md: 0 }}>
              <SoftTypography
                variant="h2"
                fontWeight="bold"
                sx={{
                  color: "#0f2c4a",
                  fontSize: { xs: "1.45rem", sm: "1.65rem", md: "2.1rem", lg: "2.35rem" },
                  lineHeight: { xs: 1.35, md: 1.25 },
                  maxWidth: { xs: "100%", md: "900px" },
                  mx: "auto",
                }}
              >
                Bibliotecă de informații
              </SoftTypography>
              <SoftTypography
                variant="body1"
                sx={{
                  color: "#5a6b85",
                  mt: 2,
                  maxWidth: "800px",
                  mx: "auto",
                  fontSize: { xs: "0.9rem", sm: "0.95rem", md: "1rem" },
                  lineHeight: 1.65,
                }}
              >
                Tot ce trebuie să știi despre incidentele motivate de ură, discriminare și procedurile de raportare
              </SoftTypography>
            </SoftBox>

            <Card sx={{ boxShadow: "0 12px 32px rgba(6, 29, 54, 0.1)", borderRadius: "xl", overflow: "visible", border: "1px solid rgba(6, 29, 54, 0.06)" }}>
              <Grid container>
                {/* Sidebar - Panou lateral */}
                <Grid item xs={12} md={3}>
                  <Sidebar
                    menuStructure={menuStructure}
                    activeSection={activeSection}
                    activeSubsection={activeSubsection}
                    activeSubSubsection={activeSubSubsection}
                    onSectionClick={setActiveSection}
                    onSubsectionClick={setActiveSubsection}
                    onSubSubsectionClick={setActiveSubSubsection}
                  />
                </Grid>

                {/* Content - Zona principală */}
                <Grid item xs={12} md={9}>
                  <SoftBox p={4} position="relative">
                    <ContentDisplay
                      content={contentData[activeSection]}
                      subsectionContent={
                        activeSubsection ? contentData[activeSection]?.subsections?.[activeSubsection] : null
                      }
                      subsubsectionContent={
                        activeSubSubsection && activeSubsection 
                          ? contentData[activeSection]?.subsections?.[activeSubsection]?.subsubsections?.[activeSubSubsection] 
                          : null
                      }
                      onSectionChange={(subsectionId) => {
                        setActiveSubsection(subsectionId);
                        setActiveSubSubsection(null);
                      }}
                    />
                    
                    {/* Call to Action Section */}
                    <SoftBox mt={6} textAlign="center" sx={{ position: "relative", zIndex: 1 }}>
                      <Divider sx={{ mb: 4 }} />
                      <SoftBox
                        sx={{
                          background: "linear-gradient(135deg, #061D36 0%, #0f2c4a 100%)",
                          borderRadius: "12px",
                          border: "1px solid rgba(255,255,255,0.06)",
                          p: 4,
                          boxShadow: "0 8px 28px rgba(6, 29, 54, 0.22)",
                        }}
                      >
                        <SoftTypography variant="h4" color="white" fontWeight="bold" mb={2}>
                          Ești pregătit să raportezi?
                        </SoftTypography>
                        <SoftTypography variant="body1" color="white" opacity={0.9} mb={3}>
                          Completează formularul de sesizare și trimite către autoritățile competente
                        </SoftTypography>
                        <SoftButton
                          variant="contained"
                          size="large"
                          onClick={handleNavigateToForm}
                          sx={{
                            bgcolor: "#FFC107",
                            color: "#061D36",
                            fontWeight: 700,
                            px: 4,
                            py: 1.5,
                            "&:hover": {
                              bgcolor: "#FFB300",
                              transform: "translateY(-2px)",
                              boxShadow: "0 6px 18px rgba(255,193,7,0.35)",
                            },
                            transition: "all 0.3s",
                          }}
                        >
                          <Icon sx={{ mr: 1 }}>send</Icon>
                          Trimite sesizare
                        </SoftButton>
                      </SoftBox>
                    </SoftBox>
                  </SoftBox>
                </Grid>
              </Grid>
            </Card>
          </Grid>
        </Grid>
      </SoftBox>
      
      <Footer />
    </PageLayout>
  );
}

export default CeTrebuieSaStii;

